<!--
  common-dialog - Backward-compatible wrapper around Modal

  @deprecated Use Modal from '@/components/ui' directly for new code.
  This component is maintained for backward compatibility with existing usages.

  Note: This component uses v-model for open state.
  New code should use Modal with :open and @close.

  Migration:
    // Before:
    <common-dialog v-model="showModal" :content="MyComponent" :bindProperties="{ data }" />

    // After:
    import { Modal } from '@/components/ui'
    <Modal :open="showModal" raw @close="showModal = false">
      <MyComponent :data="data" />
    </Modal>
-->
<template>
    <Modal
        :open="!!modelValue"
        raw
        @close="modelValue = false"
    >
        <component :is="content" v-bind="bindProperties" />
    </Modal>
</template>

<script setup lang="ts">
import { type Component } from 'vue'
import { Modal } from '@/components/ui'

defineProps<{
    content: Component
    bindProperties: { [key: string]: any }
}>()

const modelValue = defineModel<any>()
</script>
